import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './card.css';


function Card({ animal }) {

    const image = require('../assets/ace.jpeg');
    console.log(animal)
    return (
        <div>
            <div className='card'>
                <img src={animal.imageUrl} alt={animal.name} />
                <h2>{animal.name}</h2>
                <Link to={`/animal?id=${animal.id}`}>
                    <button>Find Out More!</button>
                </Link>
            </div>
        </div>
    );
}

export default Card;